import { Autocomplete, Chip, Divider, Switch, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { el } from "date-fns/locale";
import useNotification from "notification";
import React, { useState } from "react";

import { formatHoraDataLocal } from "util/date";
const colorDisponivel = "rgba(30,30,235,0.5)";
const colorAgendamentoAtual = "rgba(42, 247, 101, 0.5)"; // "#2af765"
const colorUtilizado = "rgba(125,125,125,0.2)";

function CardHorarioAgenda({ horario, reuniaoAtual, onClick, getActions, getInfoAdd, reunioes, mesa }) {
    const { showWarning } = useNotification();
    let cor = colorDisponivel;
    let reuniaoMarcada = null;
    // console.log('reuniaoAtual', reuniaoAtual)
    // console.log('horario', horario)
    if (reuniaoAtual && reuniaoAtual.horario && horario.horario === reuniaoAtual.horario.horario) {
        cor = colorAgendamentoAtual;
    } else {
        if (
            mesa &&
            mesa.horariosReserved?.length &&
            mesa.horariosReserved?.findIndex((h) => h?.horario === horario.horario) > -1
        ) {
            cor = colorUtilizado;
        }
    }
    if (reunioes) {
        for (let index = 0; index < reunioes.length; index++) {
            const r = reunioes[index];
            if (r.horario.horario === horario.horario) {
                if (r.inscricao2 && r.inscricao1) {
                    if (reuniaoAtual) {
                        if (reuniaoAtual.uid !== r.uid) {
                            reuniaoMarcada = r;
                            if (cor === colorDisponivel) cor = colorUtilizado;
                        }
                    } else {
                        reuniaoMarcada = r;
                        if (cor === colorDisponivel) cor = colorUtilizado;
                    }
                }
            }
        }
    }

    return (
        <Box
            sx={{
                backgroundColor: cor,
                minWidth: 235,
                maxWidth: 235,
                flex: 1,
                p: 1,
                m: 1,
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                borderradius: 5,
                justifyContent: "center",
                cursor: cor !== colorUtilizado && onClick ? "pointer" : "unset",
            }}
            onClick={() => {
                if (!getActions) {
                    if (cor !== colorUtilizado)
                        if (mesa) {
                            if (onClick) onClick(horario, mesa);
                        } else {
                            showWarning("Selecione uma mesa");
                        }
                }
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Typography sx={{ flex: 1, textAlign: "center" }}>{formatHoraDataLocal(horario.horario)}</Typography>
                {getActions && getActions(horario)}
            </Box>
            {reuniaoMarcada ? (
                <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                    <Typography variant="caption" noWrap>
                        P1: {reuniaoMarcada.inscricao1?.empresa.nomeEmpresaCracha}
                    </Typography>
                    <Typography variant="caption" noWrap>
                        P2: {reuniaoMarcada.inscricao2?.empresa.nomeEmpresaCracha}
                    </Typography>
                    <Typography variant="caption" noWrap>
                        {reuniaoMarcada.mesa?.name}
                    </Typography>
                </Box>
            ) : mesa &&
              mesa.horariosReserved?.length &&
              mesa.horariosReserved?.findIndex((h) => h?.horario === horario.horario) > -1 ? (
                <Box sx={{ display: "flex", flexDirection: "column", textAlign: "center" }}>
                    <Typography variant="caption" noWrap>
                        Horário da mesa reservado
                    </Typography>
                </Box>
            ) : (
                <></>
            )}
        </Box>
    );
}
function CardIntervalo({ intervalo }) {
    return (
        <Box sx={{ border: "solid 1px black", width: "100%", p: 1, textAlign: "center" }}>
            <Typography>
                {intervalo.obs ? `${intervalo.obs.toUpperCase()} - ` : ""}
                {formatHoraDataLocal(intervalo.inicio)} às {formatHoraDataLocal(intervalo.fim)}
            </Typography>
        </Box>
    );
}
export default function PainelAgendaReuniao({
    label,
    hideLegenda,
    reuniaoAtual,
    onClick,
    rodada,
    getActions,
    getInfoAdd,
    reunioes,
    participante1,
    participante2,
    mesa,
}) {
    const [mesaUsar, setMesaUsar] = useState(mesa);
    const [onlyDisponiveis, setOnlyDisponiveis] = useState(false);
    let auxDateCompare = "";
    const possiveisReunioes = rodada ? rodada.possiveisReunioes : [];
    const intervalos = rodada ? rodada.intervalos : [];
    if (!possiveisReunioes || !possiveisReunioes.length) {
        console.log("nenhuma reunião possível");
        return <Typography variant="h6">- Rodada sem horarios gerados -</Typography>;
    }
    let rExibir = possiveisReunioes.slice();
    // console.log("rExibir", rExibir)

    // Obtém a data e hora atual
    const dataHoraAtual = new Date();

    // Filtra o array de objetos com base no campo "horario"
    const objetosFiltrados = rExibir.filter((objeto) => {
        // Converte a string de "horario" para um objeto Date
        const horarioObjeto = new Date(objeto.horario);

        // Compara o "horario" do objeto com a data e hora atual
        return horarioObjeto > dataHoraAtual;
    });

    rExibir = objetosFiltrados;

    if (onlyDisponiveis) {
        let agendados = (reunioes || []).map((r) => {
            if (r.uid !== reuniaoAtual.uid) {
                if (r.inscricao1) return r.horario.horario;
            }
        });

        rExibir = rExibir.filter((r) => !agendados.includes(r.horario));
    }
    let elementos = rExibir.map((a) => {
        return { type: "agenda", obj: a, refData: a.horario };
    });
    elementos = elementos.concat(
        (intervalos || []).map((i) => {
            return { type: "intervalo", obj: i, refData: i.inicio };
        }),
    );
    elementos.sort((intervaloA, intervaloB) => {
        if (intervaloA.refData > intervaloB.refData) return 1;
        else if (intervaloA.refData < intervaloB.refData) return -1;
        else return 0;
    });

    return (
        <div>
            {!mesa && onClick && (
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Autocomplete
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option, value) => option.uid === value.uid}
                        options={rodada?.mesas || []}
                        value={mesaUsar || ""}
                        sx={{ flex: 1 }}
                        renderInput={(params) => (
                            <TextField
                                label="Mesa"
                                required={true}
                                // error={hasError}
                                // helperText={hasError ? fieldProps.meta.error : helperText}
                                variant="standard"
                                {...params}
                            />
                        )}
                        onChange={(event, value) => {
                            // Necessário para passar os valores do MUI para o Final Form imediatamente.
                            setMesaUsar(value);
                        }}
                    />
                </div>
            )}
            {!hideLegenda && (
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    Legenda
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ height: 25, width: 25, backgroundColor: colorDisponivel, margin: 5 }} />
                        Disponível
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ height: 25, width: 25, backgroundColor: colorUtilizado, margin: 5 }} />
                        Utilizado
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ height: 25, width: 25, backgroundColor: colorAgendamentoAtual, margin: 5 }} />
                        Atual
                    </div>
                    <div style={{ paddingLeft: 25, display: "flex", alignItems: "center" }}>
                        <Switch checked={onlyDisponiveis} onChange={(b) => setOnlyDisponiveis(!onlyDisponiveis)} />
                        <Typography>Exibir apenas horários disponíveis</Typography>
                    </div>
                </div>
            )}
            {elementos.length === 0 && (
                <Typography variant="h6" sx={{ textAlign: "center" }}>
                    - Nenhum horário disponível -
                </Typography>
            )}
            {elementos.length > 0 && (
                <>
                    <Divider>
                        <Chip label={formatHoraDataLocal(elementos[0].refData).split(" - ")[1]} />
                    </Divider>

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 5,
                            justifyContent: "center",
                        }}
                    >
                        {elementos.map((e, i) => {
                            if (auxDateCompare === "") {
                                auxDateCompare = e.refData.split("T")[0];
                            } else {
                                if (auxDateCompare < e.refData.split("T")[0]) {
                                    auxDateCompare = e.refData.split("T")[0];
                                    return (
                                        <Box
                                            key={i}
                                            sx={{
                                                width: "100%",
                                                p: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Divider sx={{ mb: 1, mt: 5 }}>
                                                <Chip label={formatHoraDataLocal(e.refData).split(" - ")[1]} />
                                            </Divider>

                                            {e.type === "intervalo" ? (
                                                <CardIntervalo key={i} intervalo={e.obj} />
                                            ) : (
                                                <CardHorarioAgenda
                                                    key={i}
                                                    horario={e.obj}
                                                    reuniaoAtual={reuniaoAtual}
                                                    onClick={onClick}
                                                    getActions={getActions}
                                                    getInfoAdd={getInfoAdd}
                                                    reunioes={reunioes}
                                                    mesa={mesaUsar}
                                                />
                                            )}
                                        </Box>
                                    );
                                }
                            }
                            if (e.type === "intervalo") {
                                return <CardIntervalo key={i} intervalo={e.obj} />;
                            } else {
                                return (
                                    <CardHorarioAgenda
                                        key={i}
                                        horario={e.obj}
                                        reuniaoAtual={reuniaoAtual}
                                        onClick={onClick}
                                        getActions={getActions}
                                        getInfoAdd={getInfoAdd}
                                        reunioes={reunioes}
                                        mesa={mesaUsar}
                                    />
                                );
                            }
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
